<script setup lang="ts">
  import type { StructuredFinancialReport } from '@/types/Storyblok/General/StructuredFinancialReport'
  import type { IButton } from '@/types/General/Button'

  const props = defineProps<{
    blok: {
      reports: StructuredFinancialReport[]
      title: string
      hasBottomSpacing: boolean
      buttonTitle?: string
      href?: string
      target?: string
    }
  }>()

  const getButtonData = (): IButton => ({
    title: props.blok.buttonTitle,
    href: props.blok.href,
    target: props.blok.target,
    type: 'outlined'
  })
</script>

<template>
  <div
    v-if="blok.reports.length"
    class="flex flex-col justify-between text-bt-blue-dark"
  >
    <h2
      v-if="blok.title"
      class="mb-6 text-h2 lg:mb-8"
      v-html="blok.title"
    />
    <StructuredFinancialReports
      :blok="blok.reports"
      :button="getButtonData()"
    />
  </div>
</template>
